// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"946e5a07","239":"a4ed8fbb","453":"d37ea792","455":"f276a072"}[chunkId] + ".chunk.js";
};